import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { IReviewProps,  moneyParse } from "../ReviewParser";
import { WrapCashContribution } from "../../../../../../../Wrap/Models/Models/Processes/Apply/WrapCash/WrapCashContribution";
import { PensionContribution } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContribution";
import { IsaContribution } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Isa/IsaContribution";


interface IProps extends IReviewProps {
    data:   PensionContribution | IsaContribution | WrapCashContribution
}
export const AdHocAdviserChargeReview = (props: IProps) => {
    const { data, onEditAction } = props;

    const adviceCahrgeConfig = () => {
        if (!data) {return [];}
        const defaultFormatMoney = MoneyDisplayHelper.FromatMoneyDisplay(Math.abs(0), CurrencyCode.GBP);
        const config = [
            {
                title: "Additional adviser charge",
                data: data?.AdHocAdviserCharge?.Amount ? moneyParse(data?.AdHocAdviserCharge?.Amount) : defaultFormatMoney,
            },
            {
                title: "Include other product Ongoing adviser charge",
                data: data?.OngoingAdviserChargeInstructions?.length > 0 ? "Yes" : "No",
            },
        ];
        return config;
    };

    return (
        <Accordion label="Additional adviser charge" isOpen={false} onEdit={() => onEditAction()}>
            <div className="pl-34">
                <Typography type="common" config={adviceCahrgeConfig()}></Typography>
            </div>
        </Accordion>
    );
};
